/**
 * T106: Tags Settings Page
 * Page for managing tags
 */

import { Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { TagList } from '@/components/settings/tag-list'

export function TagsPage() {
  return (
    <div className="space-y-6">
      <div>
        <Button variant="ghost" size="sm" asChild className="mb-2">
          <Link to="/settings">
            <ChevronLeft className="mr-1 h-4 w-4" />
            Back to Settings
          </Link>
        </Button>
        <h1 className="text-3xl font-bold">Tags</h1>
        <p className="mt-2 text-muted-foreground">
          Manage tags to label and filter your prompts.
        </p>
      </div>

      <TagList />
    </div>
  )
}
